import React from "react";
import { Box, Typography, TextField } from "@mui/material";

export const NameRunStep = ({
  runName,
  setRunName,
  error,
  setError,
}: {
  runName: string;
  setRunName: (name: string) => void;
  error: string;
  setError: (error: string) => void;
}) => {
  return (
    <Box>
      <Typography variant="body1" gutterBottom>
        Please provide a name for your new edited run:
      </Typography>
      <TextField
        fullWidth
        value={runName}
        variant="standard"
        sx={{ mt: -0.5 }}
        onChange={(e) => {
          setRunName(e.target.value);
          if (error) setError("");
        }}
        error={!!error}
        helperText={error}
        margin="normal"
        placeholder="Enter a descriptive name for your run"
      />
    </Box>
  );
};
